import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from 'Services/httpConfig'
import { Method } from 'Services/httpMethod'
import NotificationApiPaths from '../../endpoints'
import { createPersistentBaseQuery } from 'Services/persistent-base-query'
import {
  NOTIF_CACHE_STORE,
  NOTIF_CACHE_VERSION,
  NOTIF_DB_STORE,
  persistRules,
} from './notification.config'

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: createPersistentBaseQuery(axiosBaseQuery(), {
    persistRules: persistRules,
    storeName: NOTIF_CACHE_STORE,
    dbName: NOTIF_DB_STORE,
    version: NOTIF_CACHE_VERSION,
  }),
  tagTypes: [
    'GetUserNotification',
    'MarkNotificationListedAsSeen',
    'MarkAllReceivedAsListedDIP',
    'MarkAllListedAsSeenDIP',
  ],

  endpoints: builder => ({
    GetUserNotificationPagedFilterDIP: builder.query<any, void>({
      query: () => ({
        url: NotificationApiPaths.GetReceiverNotifications,
        method: Method.GET,
        params: { AppId: '167e96bc-42ff-41cd-9e56-9c3a42cf4c24' },
        timeout: 60 * 1000,
      }),
      providesTags: ['GetUserNotification'],
    }),

    MarkNotificationListedAsSeenDIP: builder.mutation<any, any>({
      query: data => ({
        url: NotificationApiPaths.MarkNotificationListedAsSeenDIP,
        method: Method.PUT,
        data,
      }),
      invalidatesTags: ['MarkNotificationListedAsSeen'],
    }),

    MarkAllReceivedAsListedDIP: builder.mutation<any, any>({
      query: data => ({
        url: NotificationApiPaths.MarkAllReceivedAsListedDIP,
        method: Method.PUT,
        data,
      }),
      invalidatesTags: ['MarkNotificationListedAsSeen'],
    }),

    MarkAllListedAsSeenDIP: builder.mutation<any, any>({
      query: data => ({
        url: NotificationApiPaths.MarkAllListedAsSeenDIP,
        method: Method.PUT,
        data,
      }),
      invalidatesTags: ['MarkAllListedAsSeenDIP'],
    }),
  }),
})

export const {
  useLazyGetUserNotificationPagedFilterDIPQuery,
  useGetUserNotificationPagedFilterDIPQuery,
  useMarkNotificationListedAsSeenDIPMutation,
  useMarkAllReceivedAsListedDIPMutation,
  useMarkAllListedAsSeenDIPMutation,
} = notificationApi
